import baseURL from './url';

const FAVORITES_STORAGE_KEY = 'favoritos';

const normalizeFavoriteIds = (ids = []) => (
    Array.from(new Set(
        ids
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && id > 0)
    ))
);

export const getLocalFavorites = () => {
    try {
        return normalizeFavoriteIds(JSON.parse(localStorage.getItem(FAVORITES_STORAGE_KEY)) || []);
    } catch (error) {
        return [];
    }
};

export const saveLocalFavorites = (ids) => {
    const normalizedIds = normalizeFavoriteIds(ids);
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(normalizedIds));
    window.dispatchEvent(new Event('favorites-updated'));
    return normalizedIds;
};

export const loadFavorites = async () => {
    const localFavorites = getLocalFavorites();

    try {
        const response = await fetch(`${baseURL}/customerFavoritesGet.php`, {
            method: 'GET',
            cache: 'no-store',
        });
        const data = await response.json();

        if (!data.authenticated) {
            return {
                authenticated: false,
                favoritos: localFavorites,
            };
        }

        const serverFavorites = normalizeFavoriteIds(data.favoritos || []);
        const mergedFavorites = normalizeFavoriteIds([...serverFavorites, ...localFavorites]);
        const pendingSync = mergedFavorites.filter((id) => !serverFavorites.includes(id));

        await Promise.all(pendingSync.map((idProducto) => addFavoriteToAccount(idProducto)));
        saveLocalFavorites(mergedFavorites);

        return {
            authenticated: true,
            favoritos: mergedFavorites,
        };
    } catch (error) {
        return {
            authenticated: false,
            favoritos: localFavorites,
        };
    }
};

export const addFavoriteToAccount = async (idProducto) => {
    const response = await fetch(`${baseURL}/customerFavoritesPost.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ idProducto }),
    });

    return response.json();
};

export const removeFavoriteFromAccount = async (idProducto) => {
    const response = await fetch(`${baseURL}/customerFavoritesDelete.php?idProducto=${encodeURIComponent(idProducto)}`, {
        method: 'DELETE',
    });

    return response.json();
};

export const toggleFavorite = async (idProducto, currentFavorites = [], authenticated = false) => {
    const normalizedId = Number(idProducto);
    const favorites = normalizeFavoriteIds(currentFavorites);
    const exists = favorites.includes(normalizedId);
    const nextFavorites = exists
        ? favorites.filter((id) => id !== normalizedId)
        : [...favorites, normalizedId];

    saveLocalFavorites(nextFavorites);

    if (authenticated) {
        if (exists) {
            await removeFavoriteFromAccount(normalizedId);
        } else {
            await addFavoriteToAccount(normalizedId);
        }
    }

    return nextFavorites;
};
